import { Fragment } from 'react';
import type { MySubmissionConnection } from '@gov-nx/core/hooks';
import { pageRouteResolver } from '@gov-nx/web';

interface Props {
	submissions: MySubmissionConnection['submissions'];
}

export const DataBoxMessageMySubmission = ({ submissions }: Props) => (
	<div>
		{submissions.map((submission, index) => (
			<Fragment key={submission.id}>
				{index !== 0 ? ', ' : null}
				<a
					href={pageRouteResolver('moje-podani.detail', {
						submissionId: submission.id,
					})}>
					{submission.nazev}
				</a>
			</Fragment>
		))}
	</div>
);
